import { addLocaleData, IntlProvider } from 'react-intl';
import intlEn from 'react-intl/locale-data/en';
import en from './en';
import deep from 'underscore.deep';

const defaultLanguage: string = process.env.DEFAULT_LOCALE;
const msgs = { en };

const flatMsgs = {
  en: deep.deepToFlat(en),
};

// add default react-intl locale data for formatting dates, currencies
addLocaleData([...intlEn]);

export let locale: string = defaultLanguage;
// allow default language to be overwriten by an environment variable
locale = process.env.LOCALE || defaultLanguage;

export function getMessages(lang: string): any {
  return flatMsgs[lang];
}

export const messages = msgs[locale];

export const flatMessages = getMessages(locale);

const intlProvider: IntlProvider = new IntlProvider({
  locale,
  messages: flatMessages,
});

export const { intl } = intlProvider.getChildContext();
